<template>
  <div class="section" id="liveScheduleRegistration">
    <div class="title">配信予定登録</div>
    <div class="columns">
      <div class="column">
        <p class="headline">配信スケジュール</p>

        <p class="description">配信の開始日時を設定します。</p>
        <b-datetimepicker
          class="datetimepicker_schedule"
          locale="ja-JP"
          v-model="startAt"
          :min-datetime="minDatetime"
          :disabled="!allowScheduleInput"
        >
          <template #left>
            <b-button
              label="Now"
              type="is-primary"
              icon-left="clock"
              @click="startAt = new Date()"
            />
          </template>

          <template #right>
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="startAt = null"
            />
          </template>
        </b-datetimepicker>

        <p class="description spacer">配信の終了日時を設定します。</p>
        <b-datetimepicker
          class="datetimepicker_schedule"
          locale="ja-JP"
          v-model="endAt"
          :min-datetime="minDatetime"
          :disabled="!allowScheduleInput"
        >
          <template #left>
            <b-button
              label="Now"
              type="is-primary"
              icon-left="clock"
              @click="endAt = new Date()"
            />
          </template>

          <template #right>
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="endAt = null"
            />
          </template>
        </b-datetimepicker>

        <p class="headline spacer">限定配信日時</p>

        <p class="description">限定配信の時間を設定します。</p>
        <div class="reservearea">
          <b-datetimepicker
            class="datetimepicker_reserve"
            locale="ja-JP"
            v-model="reserveStartAt"
            :min-datetime="minDatetime"
            :disabled="!allowReserveInput"
          >
            <template #left>
              <b-button
                label="Now"
                type="is-primary"
                icon-left="clock"
                @click="reserveStartAt = new Date()"
              />
            </template>

            <template #right>
              <b-button
                label="Clear"
                type="is-danger"
                icon-left="close"
                outlined
                @click="reserveStartAt = null"
              />
            </template>
          </b-datetimepicker>
          <p>〜</p>
          <b-datetimepicker
            class="datetimepicker_reserve"
            locale="ja-JP"
            v-model="reserveEndAt"
            :min-datetime="minDatetime"
            :disabled="!allowReserveInput"
          >
            <template #left>
              <b-button
                label="Now"
                type="is-primary"
                icon-left="clock"
                @click="reserveEndAt = new Date()"
              />
            </template>

            <template #right>
              <b-button
                label="Clear"
                type="is-danger"
                icon-left="close"
                outlined
                @click="reserveEndAt = null"
              />
            </template>
          </b-datetimepicker>
        </div>

        <p class="headline spacer">配信タイトル</p>
        <input class="title_input" type="text" v-model="title"/>

        <p class="headline spacer">サムネイル登録</p>
        <div class="thumbnail">
          <figure class="image thumbnail__image">
            <b-image :src="previewImageUrl" ratio="400by255" />
          </figure>
          <b-field label="">
            <b-upload @input="onFileChanged" drag-drop expanded>
              <div class="content has-text-centered preview__upload">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your files here or click to upload</p>
              </div>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
    <div class="buttons">
      <b-button class="button cancel" @click.native="cancel">
        キャンセル
      </b-button>
      <b-button
        class="button submit"
        @click.native="submitLiveSchedule"
        :loading="sending"
      >
        登録する
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid'
import * as reserveServices from '@/services/reserveServices';
import liveScheduleMixin from '@/mixins/liveScheduleMixin'

export default {
  name: 'LiveScheduleRegistration',
  mixins: [liveScheduleMixin],
  data() {
    return {
      minDatetime: moment().toDate(),
      sending: false
    };
  },
  async mounted() {
    this.loadProfile();
  },
  methods: {
    async loadProfile() {
      if (this.$store.state.user.thumbnailURL) {
        this.previewImageUrl = this.$store.state.user.thumbnailURL;
      }
    },
    async submitLiveSchedule() {
      if (this.sending) return;

      let validateResult = await this.validate();
      if (!validateResult) {
        return;
      }

      try {
        this.sending = true;
        const id = uuidv4();

        let doc = {
          id: id,
          userId: this.$store.state.auth.uid,
          startAt: this.startAt,
          endAt: this.endAt,
          reserveStartAt: this.reserveStartAt,
          reserveEndAt: this.reserveEndAt,
          title: this.title,
          imageFile: this.imageFile,
          thumbnailURL: this.$store.state.user.thumbnailURL
        };

        await this.$store.dispatch('live/addUpComingLive', doc);

        if (doc.reserveStartAt && doc.reserveEndAt) {
          await reserveServices.createReserveDoc(id, doc.reserveStartAt, doc.reserveEndAt)
        }

        this.sending = false;

        this.$emit("action", {
          menu: "liveSchedule"
        })
      } catch (err) {
        this.sending = false;
        console.error(err);
        throw err;
      }
    },
    cancel() {
      this.$emit("action", {
        menu: "liveSchedule"
      })
    },
    onFileChanged(inputFile) {
      this.imageFile = inputFile;
      this.previewImageUrl = URL.createObjectURL(inputFile);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-schedule-registration.scss';
</style>
